import React, { useState } from "react"
import * as classNames from "./BlockSearchResult.module.scss"
import { Swiper, SwiperSlide } from "swiper/react"
import { Link } from "gatsby-plugin-modal-routing-3"

// Import Swiper styles
import "swiper/css"
import "swiper/css/pagination"
import Card from "../../../blocks/card/Card"
import Image from "../../../blocks/image/Image"
import { formatDate } from "../../../../../../utils/formatDate"
import Button from "../../../blocks/button/Button"
import { tagUrl } from "../../../../../../utils/routeLib"
import Icon from "../../../blocks/icon/Icon"

function BlockSearchResult({ article }) {
  const [showAllTags, setShowAllTags] = useState(false)

  const imageFormat = (url) => {
    if (!url) return
    const lastSlashIndex = url.lastIndexOf("/")
    const baseUrl = url.substring(0, lastSlashIndex + 1)
    const filename = url.substring(lastSlashIndex + 1)
    const lastDotIndex = filename.lastIndexOf(".")
    let f = filename
    if (lastDotIndex !== -1) {
      f = filename.substring(0, lastDotIndex)
    }

    return {
      L: {
        ext: ".webp",
        url: `${baseUrl}L_${f}.webp`,
        hash: "L_" + f,
        mime: "image/webp",
        name: "L_" + filename,
        path: null,
        size: 13.87,
        width: 770,
        height: 514,
      },
      M: {
        ext: ".webp",
        url: `${baseUrl}M_${f}.webp`,
        hash: "M_" + f,
        mime: "image/webp",
        name: "M_" + filename,
        path: null,
        size: 10.27,
        width: 590,
        height: 394,
      },
      S: {
        ext: ".webp",
        url: `${baseUrl}S_${f}.webp`,
        hash: "S_" + f,
        mime: "image/webp",
        name: "S_" + filename,
        path: null,
        size: 6.27,
        width: 390,
        height: 260,
      },
      XL: {
        ext: ".webp",
        url: `${baseUrl}XL_${f}.webp`,
        hash: "XL_" + f,
        mime: "image/webp",
        name: "XL_" + filename,
        path: null,
        size: 29.87,
        width: 1440,
        height: 960,
      },
      thumbnail: {
        ext: ".jpg",
        url: `${baseUrl}thumbnail_${f}.webp`,
        hash: "thumbnail_" + f,
        mime: "image/webp",
        name: "thumbnail_" + filename,
        path: null,
        size: 5.37,
        width: 234,
        height: 156,
      },
    }
  }
  return (
    <>
      <Card
        className={`${classNames.ArticleCard} p-2`}
        tag="article"
      >
        <div className={classNames.img}>
          <Link to={article?.route}>
            {" "}
            <Image
              dataSizesPreset={"article"}
              imgSrc={article?.image}
              formats={imageFormat(article?.image)}
            />{" "}
          </Link>
          <div className={`${classNames.dateMobile}`}>
            <time>{formatDate(article?.date)}</time>
          </div>
        </div>

        <div className={classNames.articleContent}>
          <Link to={article?.route}>
            <h3>{article?.title}</h3>
          </Link>
          <Link to={article?.route}>
            <p>{article?.description}</p>
          </Link>
          <div className={classNames.tagsContainer}>
            <Swiper
              spaceBetween={10}
              slidesPerView={"auto"}
              className={classNames.tagsSwiper}
            >
              {article?.tags.map((tag, i) => (
                <SwiperSlide className={classNames.tag}>
                  <Button
                    key={tag}
                    aspect="tag"
                    size="small"
                    to={tagUrl(tag.attributes.autoRoute)}
                    color="secondary"
                  >
                    #{tag.attributes.label}
                  </Button>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className={classNames.tagsMobile}>
              <div className={classNames.tagMobile}>
                {showAllTags
                  ? article?.tags.map((tag, i) => (
                      <Button
                        key={tag.attributes.label}
                        aspect="tag"
                        to={tag.attributes.autoRoute}
                        color="secondary"
                      >
                        #{tag.attributes.label}
                      </Button>
                    ))
                  : article?.tags.slice(0, 3).map((tag, i) => (
                      <Button
                        key={tag.attributes.label}
                        aspect="tag"
                        to={tag.attributes.autoRoute}
                        color="secondary"
                      >
                        #{tag.attributes.label}
                      </Button>
                    ))}
              </div>
              {article?.tags.length > 3 && (
                <div className={classNames.buttonTag}>
                  {!showAllTags && (
                    <Button
                      aspect="unstyled"
                      color="primary"
                      onClick={() => setShowAllTags(true)}
                    >
                      Voir plus
                      <Icon
                        icon="arrow"
                        color="var(--primary-color)"
                        width="20px"
                        height="20px"
                      />
                    </Button>
                  )}
                </div>
              )}
            </div>
            <div className={classNames.iconContainer}>
              <div className={`${classNames.date}`}>
                <time>{formatDate(article?.date)}</time>
              </div>
              <div className={classNames.icon}>
                <Icon
                  icon="calendar"
                  color="var(--gris)"
                  width="20px"
                  height="20px"
                />
              </div>
            </div>
          </div>
        </div>
      </Card>
    </>
  )
}

export default BlockSearchResult
